import React from 'react';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { FeatureSpecsEntities, FeatureSpecsPaths, VehicleModel } from 'client/data/models/vehicle-v2';
import { FeaturesSection } from 'site-modules/features-specs/components/features-section/features-section';
import { getCustomMapFeatures, getOverviewMap } from 'site-modules/features-specs/utils/features-specs';
import { FeaturesSpecsParams } from 'site-modules/shared/utils/features-specs/params';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export function FeaturesSpecsOverviewUI({ params, styleOverview = null, isMobile, showBreadcrumbs = false }) {
  const { styleAttributes } = styleOverview;
  const featuresSectionProps = { params, isMobile, style: styleOverview };

  return (
    <FeaturesSection
      {...featuresSectionProps}
      category="Overview"
      showBreadcrumbs={showBreadcrumbs}
      features={getCustomMapFeatures(styleOverview, getOverviewMap(styleAttributes))}
      isFirstSection
    />
  );
}

FeaturesSpecsOverviewUI.propTypes = {
  params: FeaturesSpecsParams.isRequired,
  isMobile: PropTypes.bool.isRequired,
  styleOverview: FeatureSpecsEntities.FeatureStyleOverviewEntity,
  showBreadcrumbs: PropTypes.bool,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const FeaturesSpecsOverview = connect(mapStateToProps)(
  connectToModel(FeaturesSpecsOverviewUI, {
    styleOverview: bindToPath(
      ({ params, styleId }) => FeatureSpecsPaths.buildFeaturesOverviewPath({ ...params, styleId }),
      VehicleModel
    ),
  })
);
